import { render, staticRenderFns } from "./VerMiNotificacion.vue?vue&type=template&id=a1d27128&"
import script from "./VerMiNotificacion.vue?vue&type=script&lang=js&"
export * from "./VerMiNotificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports